var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "i",
    {
      class: [
        "message-icon",
        "el-icon-s-comment",
        _vm.hereList.length > 0 ? "message-icon-active" : "",
      ],
      on: {
        click: function ($event) {
          _vm.showDialog = true
        },
      },
    },
    [
      _c("span", { staticClass: "message-count" }, [
        _vm._v(_vm._s(_vm.hereList.length > 0 ? `${_vm.hereList.length}` : "")),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("TABLE_HEADER_Message"),
            top: "10vh",
            visible: _vm.showDialog,
            width: "45%",
            "close-on-click-modal": false,
            "append-to-body": "",
          },
          on: {
            close: function ($event) {
              _vm.showDialog = false
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "messageViewer" },
            [
              _vm.hereList && _vm.hereList.length > 0
                ? _vm._l(_vm.hereList, function (item, index) {
                    return _c(
                      "el-row",
                      { key: item.id, staticClass: "itemWarp" },
                      [
                        _c(
                          "el-col",
                          {
                            class:
                              item.sendUserType == _vm.getUser.userType
                                ? "floatRight"
                                : "floatLeft",
                            attrs: { span: 18 },
                          },
                          [
                            _c("el-avatar", {
                              class:
                                item.sendUserType == _vm.getUser.userType
                                  ? "floatRight"
                                  : "floatLeft",
                              attrs: { size: "small", src: _vm.circleUrl },
                            }),
                            _c(
                              "div",
                              {
                                staticClass: "messageWarp",
                                class:
                                  item.sendUserType == _vm.getUser.userType
                                    ? "floatRight"
                                    : "floatLeft",
                              },
                              [
                                _c("div", { staticClass: "messageBy" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(item.sendUserName) +
                                      "【"
                                  ),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatDateTime")(
                                          item.createDate
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v("】\n                            "),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass: "messageContent",
                                    class:
                                      item.sendUserType == _vm.getUser.userType
                                        ? "rightMessage"
                                        : "leftMessage",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(item.message) +
                                        "\n                                "
                                    ),
                                    item.sendUserId === _vm.getUser.userId
                                      ? _c(
                                          "el-popconfirm",
                                          {
                                            attrs: {
                                              title: _vm.$t("msg_delete_sure"),
                                            },
                                            on: {
                                              confirm: function ($event) {
                                                return _vm.deleteMessage(
                                                  item,
                                                  index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-delete deleteButton leftButton",
                                              attrs: { slot: "reference" },
                                              slot: "reference",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  })
                : _c("span", { staticStyle: { "margin-top": "20px" } }, [
                    _vm._v(_vm._s(_vm.$t("INSIGHTS_NO_DATA"))),
                  ]),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "addMessage" },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  resize: "none",
                  maxlength: "300",
                  "show-word-limit": "",
                  rows: 3,
                  placeholder: _vm.$t("ENTER_MESSAGE_CONTENT"),
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    if (
                      $event.ctrlKey ||
                      $event.shiftKey ||
                      $event.altKey ||
                      $event.metaKey
                    )
                      return null
                    return _vm.onSendCommit.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.input,
                  callback: function ($$v) {
                    _vm.input = $$v
                  },
                  expression: "input",
                },
              }),
              _c("i", {
                staticClass: "el-icon-s-promotion wl-icon-send",
                attrs: { title: _vm.$t("comment_send") },
                on: { click: _vm.onSendCommit },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }